import { useCallback, useState } from 'react'

type OpenDropdown = 'watchlist' | 'savedSearches' | 'notifications'
type OpenDropdownOrNull = OpenDropdown | null
type SetOpenDropdown = React.Dispatch<React.SetStateAction<OpenDropdownOrNull>>

export type OpenDropdownState = {
  openDropdown: OpenDropdownOrNull
  setOpenDropdown: SetOpenDropdown
}

export const useOpenDropdownToggle = ({
  key,
  openDropdownState: { openDropdown, setOpenDropdown },
}: {
  key: OpenDropdown
  openDropdownState: OpenDropdownState
}) => {
  return {
    isOpen: openDropdown === key,
    onOpenChange: useCallback(
      (open: boolean) => {
        setOpenDropdown(open ? key : (prev) => (prev === key ? null : prev))
      },
      [setOpenDropdown, key]
    ),
  }
}

export const useOpenDropdownState = (): OpenDropdownState => {
  const [openDropdown, setOpenDropdown] = useState<OpenDropdownOrNull>(null)
  return {
    openDropdown,
    setOpenDropdown,
  }
}
